import { useEffect, useState } from "react";

import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import { PlannerLayout } from "../../layouts";

import { ProfileDataView } from "../account/views/ProfileDataView";
import { OrganizationInterface } from "../../interfaces";
import { LoadingScreen } from "../../ui/components/LoadingScreen";
import { getPlannerOrganization } from "../../api/providers/plannerOrganizationProviders";

export const OrganizationPage = () => {
  const [loading, setLoading] = useState(false);
  const [organization, setOrganization] =
    useState<OrganizationInterface | null>(null);

  useEffect(() => {
    getOrganizationData();
  }, []);

  const getOrganizationData = async () => {
    try {
      setLoading(true);
      const result = await getPlannerOrganization();
      if (result.ok) {
        setOrganization(result.data);
      }
    } catch (error) {
      console.error("Error obteniendo los datos del usuario:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PlannerLayout title="organización">
      <Container
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Typography fontSize={40} color={"white"}
          >
            Organización
          </Typography>
        </Box>

        {loading ? (
          <LoadingScreen />
        ) : (

          <Grid container justifyContent="center">
            <Grid item xs={12} md={12}>
              <Paper elevation={6} sx={{ borderRadius: 2 }}>
                <Box p={2}>
                  <ProfileDataView
                    organizationData={organization}
                    setOrganizationData={setOrganization}
                    getOrganizationData={getOrganizationData}
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        )}
      </Container>
    </PlannerLayout>
  );
};
